import api from './api';

class UserClienteService {
  /**
   * Listar todos os clientes que um usuário tem acesso
   */
  async listarClientesDoUsuario(userId) {
    const response = await api.get(`/users/${userId}/clientes`);
    return response.data;
  }

  /**
   * Vincular clientes ao usuário (adiciona novos, mantém existentes)
   */
  async vincularClientes(userId, clienteIds) {
    const response = await api.post(`/users/${userId}/clientes`, { clienteIds });
    return response.data;
  }

  /**
   * Substituir todos os clientes do usuário
   * Remove todos os vínculos antigos e cria novos
   */
  async substituirClientes(userId, clienteIds) {
    const response = await api.put(`/users/${userId}/clientes`, { clienteIds });
    return response.data;
  }

  /**
   * Remover um cliente específico do usuário
   */
  async desvincularCliente(userId, clienteId) {
    const response = await api.delete(`/users/${userId}/clientes/${clienteId}`);
    return response.data;
  }

  /**
   * Verificar se usuário tem acesso a um cliente específico
   */
  async verificarAcessoCliente(userId, clienteId) {
    const response = await api.get(`/users/${userId}/clientes/${clienteId}/verificar`);
    return response.data;
  }

  /**
   * Obter clientes do usuário autenticado (atual)
   */
  async listarMeusClientes() {
    // Pega o usuário do localStorage/contexto
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user || !user.id) {
      throw new Error('Usuário não autenticado');
    }
    return this.listarClientesDoUsuario(user.id);
  }
}

const userClienteService = new UserClienteService();
export default userClienteService;
